import { render, staticRenderFns } from "./CommercialPrintDetailsCard.vue?vue&type=template&id=60736dee&scoped=true"
import script from "./CommercialPrintDetailsCard.vue?vue&type=script&lang=js"
export * from "./CommercialPrintDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./CommercialPrintDetailsCard.vue?vue&type=style&index=0&id=60736dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60736dee",
  null
  
)

export default component.exports